// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__35gJ8","fileDisabled":"File_fileDisabled__3b_Mn"};